import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {useSelector} from 'react-redux';

const AulaList = ({ itemsPerPage, items, content_4, assistidas}) => {

  const [currentItems, setCurrentItems] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items?.slice(itemOffset, endOffset));
  }, [itemOffset, itemsPerPage, items]);
  
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems && currentItems.map((aula, index) => (
        <div key={index} className="col-xxl-12">
          <div className="course__item list white-bg mb-10 fix">
            <div className="row gx-0">
              
            {/* <div className="col-xxl-2 col-xl-2 col-lg-2">
                <div className="course__thumb course__thumb-list w-img p-relative fix">
                  <Link to={`/modulo/${aula.modulo_fk}/aula/assistir/${aula.cd_aula}`}>
                  {(assistidas.includes(aula.cd_aula)) && <img src={"https://v1.profaprizattera.com.br/uploads/aula/" + aula.file} alt="" style={{filter: "grayscale(100%)"}} /> }
                  {(!assistidas.includes(aula.cd_aula)) && <img src={"https://v1.profaprizattera.com.br/uploads/aula/" + aula.file} alt="" /> }
                  </Link>
                </div>
              </div> */}

              <div className="col-xxl-12 col-xl-12 col-lg-12">
                <div className="course__right">
                  <div className={`course__content course__content-4`}>
                    <div className="course__meta d-flex align-items-center">
                      <div className="course__lesson">
                        {/* <span><i className="far fa-book-alt"></i> Pri Zattera</span> */}
                      </div>
                      
                    </div>
                    <h3>
                      <Link to={`/modulo/${aula.modulo_fk}/aula/assistir/${aula.cd_aula}`}>{((assistidas.includes(aula.cd_aula)) && <i className="fa fa-check fa-check-green" style={{color: '#4BB543'}}></i>) || <i className="fa fa-check" style={{color: 'gray'}}></i>} {aula.titulo}</Link>
                    </h3>
                    
                  </div>
                  {/* <div className={`course__more course__more-3'}
                   d-flex justify-content-between align-items-center`}>
                    
                    <div className="course__btn">
                      <Link to={`/modulo/${aula.modulo_fk}/aula/assistir/${aula.cd_aula}`} className="link-btn">
                        Saiba mais
                        <i className="far fa-arrow-right"></i>
                        <i className="far fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

    </>
  );
};

export default AulaList;